<div class="dialog">
    <label class="title">{{data.isResponse === true ? 'Respuesta de SaludWeb' : 'Solicitud desde Historia Clínica'}}</label>
    <textarea disabled class="json-area" [value]="data.jsonRequestResponse"></textarea>
</div>
